export const  removeQuotes = (string) => {
    return string.replace(/['"]+/g, '')
}
